import { render, staticRenderFns } from "./InterCard.vue?vue&type=template&id=03b05c2f"
import script from "./InterCard.vue?vue&type=script&lang=js"
export * from "./InterCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports